module.exports = __webpack_public_path__ + "static/what_you_get_art@2x-740e5472105198e9acd04a7fa12a75a5.png";